import { Icon } from "@iconify/react";
import "../css/cart.css";
import { useNavigate } from "react-router-dom";
import spongeBob from "../media/spongebob.avif";
import useGenStore from "../store/genstore";
import useFirebaseStore from "../store/firebasestore";
import Swal from "sweetalert2";
import moana from "../media/moana.avif"
import unicorn from "../media/unicorn.avif"
import dragon from "../media/dragon.avif"
import { motion } from "motion/react";
import mario from "../media/mario.avif"
import { updateDoc,doc } from "firebase/firestore";
import cat from "../media/cat.avif"
import { db } from "../firebase/firebaseConfig";
import axios from "axios";
import frozen from "../media/frozen.avif"
import sonic from "../media/sonic.avif"
import spongebob from "../media/spongebob.avif"
import { useEffect, useState } from "react";

function Cart() {
  const navigate = useNavigate();

  const setCartView = useGenStore((s) => s.setCartView);
  const cartItemsFromStore = useFirebaseStore((s) => s.cartItems);
  const userID = useFirebaseStore((s) => s.userID);
  const authStatus = useFirebaseStore((s) => s.authStatus);
  const [gTotal, setGtotal] = useState(0);

  const cartItems =
    authStatus === "authenticated"
      ? cartItemsFromStore
      : JSON.parse(localStorage.getItem("guestCartItems") || "[]");

  const stickerArray=[
    {avatarImg:spongebob, avatarName: "Sponge Bob", index:0},
    {avatarImg:sonic, avatarName: "Sonic", index:1},
    {avatarImg:moana, avatarName: "Mirabel", index:2},
    {avatarImg:dragon, avatarName: "Dinosaur", index:3},
    {avatarImg:mario, avatarName: "Super Mario", index:4},
    {avatarImg:cat, avatarName: "Bluey", index:5},
    {avatarImg:frozen, avatarName: "Elsa", index:6},
    {avatarImg:unicorn, avatarName: "Unicorn", index:7},
    {avatarImg:"", avatarName: "No Avatar", index:8},
  ]

useEffect(()=>{
    let totalCost=0
    cartItems.forEach(item => {
      const batchNumbers =(item.count/item.batchSize)
       totalCost +=batchNumbers * item.costPerBatch;
    });
          setGtotal(totalCost)

},[cartItems])

const deleteItem = async (id) => {
  const updatedCart = cartItems.filter(item => item.id !== id);

  if (authStatus !== "authenticated" || !userID) {
    localStorage.setItem("guestCartItems", JSON.stringify(updatedCart));
    useFirebaseStore.setState({ cartItems: updatedCart });
    return;
  }

  await updateDoc(doc(db, "Users", userID), {
    cartItems: updatedCart
  });
};

const increase = async (cartItem) => {
  const batch = cartItem.batchSize;

  const updatedCart = cartItems.map(item =>
    item.id === cartItem.id
      ? { ...item, count: item.count + batch }
      : item
  );

  if (authStatus !== "authenticated" || !userID) {
    localStorage.setItem("guestCartItems", JSON.stringify(updatedCart));
    useFirebaseStore.setState({ cartItems: updatedCart });
    return;
  }

  await updateDoc(doc(db, "Users", userID), {
    cartItems: updatedCart
  });
};

const decrease = async (cartItem) => {
  const batch = cartItem.batchSize;

  const updatedCart = cartItems.map(item =>
    item.id === cartItem.id
      ? { 
          ...item, 
          count: Math.max(batch, item.count - batch) 
        }
      : item
  );

  if (authStatus !== "authenticated" || !userID) {
    localStorage.setItem("guestCartItems", JSON.stringify(updatedCart));
    useFirebaseStore.setState({ cartItems: updatedCart });
    return;
  }

  await updateDoc(doc(db, "Users", userID), {
    cartItems: updatedCart
  });
};

const toCheckOut = () => {
  if (cartItems.length <= 0) {
    Swal.fire({
      icon: "warning",
      title: "Your Cart is Empty",
      text: "Please add at least one item to your cart before proceeding to checkout.",
      confirmButtonText: "Add Item",
      confirmButtonColor: "#5EA7FA"
    }).then(()=>{
      navigate("/branding")
    });
    return;
  }

  

  navigate(`/checkout/${gTotal}`);
}

const editItem =(e)=>{
  setCartView(false)
  navigate(`/branding-edit/${e}`)
}

  return (
    <div className="cartRigtCorner">
      <div className="crcCont">
        <div className="cartTitle">
          <div className="cartTitleNo">
            <span className="ct">My Cart </span>
          </div>
          <div className="myCartCancel" onClick={() => setCartView(false)}>
            <Icon className="faIcon" icon="solar:arrow-right-linear" />
          </div>
        </div>
        <div className="CartItemsWrap">
          {cartItems.map((cartItem,index)=>(
                <div
                key={cartItem.id}
                className="cartItemCard">
            <div className="cartItemCardPlacer">
              <div className="cartItemImgData">
                <div className="cartItemImg">
              
                  <div className={`cartItemImgCont cartItemImgCont${cartItem.stickerIndex}`}>
                   {stickerArray[cartItem.stickerIndex]?.avatarImg && (
  <div className="cartItemActImg">
    <img src={stickerArray[cartItem.stickerIndex].avatarImg} alt="" />
  </div>
)}
                    <div className="cartItemActName">
                      <span className={`colorIndex${cartItem.stickerIndex}`}>{cartItem.studentName}</span>
                    </div>
                  </div>
                </div>
                <div className="cartItemData">
                  <span>Type: {cartItem.labelType}</span>
                  <span>Cost: Ksh. {((cartItem.count/cartItem.batchSize)*cartItem.costPerBatch).toLocaleString()}</span>
                  <div className="cartItemDataCounter">
                  <div className="cicIcon" onClick={() => decrease(cartItem)}>
  <Icon className="faIcon" icon="solar:minus-circle-line-duotone" />
</div>
                    <div className="cicIconNo">
                      <p>{cartItem.count}</p>
                    </div>
                 <div className="cicIcon" onClick={() => increase(cartItem)}>
  <Icon className="faIcon" icon="solar:add-circle-line-duotone" />
</div>
                  </div>
                </div>
              </div>
              <div className="cartItemActions">
                <div className="ciaAction"

                  onClick={() => editItem(cartItem.id)}

                
                >
                  <Icon
                    className="faIcon"
                    icon="solar:pen-new-square-line-duotone"
                  />
                </div>
             <div 
  className="ciaAction"
  onClick={() => deleteItem(cartItem.id)}
>
  <Icon
    className="faIcon"
    icon="solar:trash-bin-trash-line-duotone"
  />
</div>
              </div>
            </div>
          </div>
          ))}
       
      
        </div>
        <div className="cartBtm">
          <div className="cartBtmTotal">
            <p>Total</p>
            <p>Ksh. {gTotal.toLocaleString()}</p>
          </div>
          <div className="cartBtmButtons">
 <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}        
                          className="secBtn"
              onClick={() => {
                setCartView(false);
                navigate("/branding");
              }}
            >
              Add Label
            </motion.button>
 <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}             
                     className="priBtn"
              onClick={() => {
                setCartView(false);
                toCheckOut()

              }}
            >
              Checkout
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cart;